import React from 'react';
import SpinnerView from '../../components/spinner/spinner-view';

class HomeView extends React.Component {

  state = {
    template: {},
    compiled: ''
  }

  componentDidMount() {
    this.props.dispatchGetInvoiceHTML(this.props.match.params.companyId, this.props.match.params.entityId, this.props.match.params.invoiceId)
  }

  scrollToTop = () => window.scrollTo(0, 0);

  // Paid / Unpaid / Credit, in the glass pill language used elsewhere.
  // Inline styles with literal fallbacks because this page is client-facing
  // and is not guaranteed to have the token stylesheets applied.
  renderStatusBadge = () => {
    const detail = this.props.invoice && this.props.invoice.detail;
    if (!detail || detail.hideInvoiceLabel) return null;

    let label = 'Unpaid';
    let fg = '#B4383D';
    let bg = 'rgba(218,74,79,0.14)';

    if (detail.isCreditNote) {
      label = 'Credit note'; fg = '#8A3F07'; bg = 'rgba(229,160,0,0.18)';
    } else if (detail.isQuote) {
      label = 'Quote'; fg = '#5A6B7A'; bg = 'rgba(138,152,166,0.16)';
    } else if (detail.paid) {
      label = 'Paid'; fg = '#147A51'; bg = 'rgba(27,159,105,0.14)';
    }

    return (
      <div style={{
        position: 'absolute', top: 18, right: 18, zIndex: 2,
        display: 'inline-flex', alignItems: 'center', gap: 7,
        background: bg, color: fg,
        border: '1px solid rgba(255,255,255,0.6)',
        borderRadius: 999, padding: '7px 16px',
        fontSize: 12, fontWeight: 700, letterSpacing: 0.6,
        textTransform: 'uppercase',
        fontFamily: 'var(--font-display, inherit)',
        boxShadow: '0 4px 14px rgba(15,31,46,0.10)',
        backdropFilter: 'blur(6px)',
      }}>
        <span aria-hidden="true" style={{ width: 7, height: 7, borderRadius: '50%', background: fg }}></span>
        {label}
      </div>
    );
  };

  // The iframe has no intrinsic height, so match it to the document inside.
  // Re-measured shortly after load because the logo is a remote <img> and the
  // page grows once it arrives. sandbox="allow-same-origin" keeps scripts
  // disabled while still allowing this measurement.
  sizeFrame = () => {
    const fit = () => {
      try {
        const doc = this.frame && this.frame.contentDocument;
        if (!doc || !doc.documentElement) return;
        this.frame.style.height = Math.max(
          doc.documentElement.scrollHeight,
          doc.body ? doc.body.scrollHeight : 0
        ) + 'px';
      } catch (e) { /* cross-origin or torn down — leave the default height */ }
    };
    fit();
    [150, 600, 1500].forEach((ms) => setTimeout(fit, ms));
  };

  render() {

    if (this.props.invoice) console.log(this.props.invoice.detail);
    var keys = {}
    var sec = "";

    if (this.props.invoice && this.props.invoice.detail) {
      keys = this.props.invoice.detail.keys;
      sec = this.props.invoice.detail.sec;
    }

    return (
      <div className="pt-5 text-center" style={{ backgroundColor: '#FBFCFF' }}>
        <SpinnerView showSpinner={this.props.loading} />

        {this.props.invoice && this.props.invoice.detail && !!this.props.invoice.detail.payfast &&
          <div className="col-12" style={{ display: 'flex', justifyContent: 'center' }}>
            {this.props.invoice && this.props.invoice.detail && !!!this.props.invoice.detail.paid && <div className='mb-4'>
              <form action={this.props.invoice.detail.url} method="POST">
                {Object.keys(keys).map((key, i) => {
                  return <input type="hidden" key={i} name={key} value={keys[key]} />
                })}

                <input type="hidden" name="signature" value={sec} />
                <button type="submit" style={{ background: 'linear-gradient(135deg, var(--primary), var(--primary-dark))', border: 'none', color: '#fff', borderRadius: 12, padding: '12px 28px', fontWeight: 700, fontFamily: 'var(--font-display)', fontSize: 16, cursor: 'pointer', boxShadow: '0 8px 22px rgba(13,161,178,0.32)' }}>Pay Now</button>
              </form>
            </div>}
          </div>}


        <div className="col-12" style={{ display: 'flex', justifyContent: 'center' }}>
          <div className="position-relative p-3 card elevation-3" style={{ display: 'block', width: 820, backgroundColor: '#FBFCFF' }}>
            {/* Status badge. This used to be AdminLTE's diagonal .ribbon, but
                adminlte.min.css was dropped in favour of a hand-written shim
                that does not cover .ribbon — so it rendered as a full-width red
                bar. A glass pill matches the status pills in the invoice list. */}
            {this.renderStatusBadge()}

            {/* The invoice html is a complete standalone document with its own
                <style>. Injecting it into the page let the app's CSS cascade in
                — the wrapper's Bootstrap `text-center` centred every line, so
                this view never matched the PDF. An iframe gives it the isolated
                document it was written for, so it renders exactly as it prints.
                srcDoc is same-origin, so the height can be measured on load. */}
            {this.props.invoice && this.props.invoice.html && (
              <iframe
                title="Invoice"
                srcDoc={this.props.invoice.html.replace(/(<script)/gi, 'illegalscript')}
                sandbox="allow-same-origin"
                scrolling="no"
                style={{ width: '100%', border: 'none', display: 'block', overflow: 'hidden' }}
                ref={(el) => { this.frame = el; }}
                onLoad={this.sizeFrame}
              />
            )}

            <div>powered by <img src="/moneyapp_blue.png" alt="AdminLTE Logo" style={{ marginRight: 15, height: 15 }} /></div>
          </div>
        </div>



      </div >
    );
  }
}

export default HomeView;
